import { OffrLogo } from "./OffrLogo";

const corePortals = [
  { logo: "/ats-logos/darwinbox-ui.webp", name: "Darwinbox", tone: "coral", note: "known ATS", fit: "wide" },
  { logo: "/ats-logos/peoplestrong.svg", name: "PeopleStrong", tone: "mint", note: "known ATS", fit: "wide" },
  { logo: "/ats-logos/workday.svg", name: "Workday", tone: "violet", note: "known ATS", fit: "wide" },
  { logo: "/ats-logos/sap.svg", name: "SAP SuccessFactors", tone: "gold", note: "known ATS", fit: "square" },
  { logo: "/ats-logos/oracle.svg", name: "Oracle Taleo", tone: "rose", note: "known ATS", fit: "square" },
  { logo: "/ats-logos/greenhouse.svg", name: "Greenhouse", tone: "green", note: "known ATS", fit: "square" },
  { logo: "/ats-logos/lever-ui.webp", name: "Lever", tone: "sky", note: "known ATS", fit: "wide" }
] as const;

const targetPortals = [
  { logo: null, mark: "SR", name: "SmartRecruiters", tone: "rose", note: "coverage target", fit: "square" },
  { logo: null, mark: "IC", name: "iCIMS", tone: "ink", note: "coverage target", fit: "square" },
  { logo: null, mark: "ZR", name: "Zoho Recruit", tone: "coral", note: "coverage target", fit: "square" },
  { logo: null, mark: "FT", name: "Freshteam", tone: "mint", note: "coverage target", fit: "square" },
  { logo: null, mark: "CS", name: "Cornerstone", tone: "violet", note: "coverage target", fit: "square" },
  { logo: null, mark: "AP", name: "Custom employer portal", tone: "green", note: "semantic map", fit: "square" }
] as const;

type Portal = (typeof corePortals)[number] | (typeof targetPortals)[number];

const topPortals: readonly Portal[] = [
  corePortals[2], corePortals[4], targetPortals[0], corePortals[0],
  corePortals[5], targetPortals[2], corePortals[3]
];

const bottomPortals: readonly Portal[] = [
  targetPortals[5], corePortals[1], targetPortals[4], corePortals[6],
  targetPortals[1], corePortals[0], targetPortals[3], corePortals[2]
];

function Rail({ portals, reverse = false }: { portals: readonly Portal[]; reverse?: boolean }) {
  return (
    <div className={`portal-rail__track ${reverse ? "is-reverse" : ""}`}>
      {[...portals, ...portals].map((portal, index) => (
        <span className="portal-pill" key={`${portal.name}-${index}`}>
          <i className={`portal-pill__mark portal-pill__mark--${portal.tone} portal-pill__mark--${portal.fit}`}>
            {portal.logo
                ? <img src={portal.logo} alt="" decoding="async" loading="lazy" />
              : "mark" in portal
                ? <b>{portal.mark}</b>
                : <OffrLogo markOnly />}
          </i>
          <span>
            <strong>{portal.name}</strong>
            <small>{portal.note}</small>
          </span>
        </span>
      ))}
    </div>
  );
}

export function PortalRail() {
  return (
    <div className="portal-rail" aria-label="Portal coverage targets">
      <Rail portals={topPortals} />
      <Rail portals={bottomPortals} reverse />
    </div>
  );
}
